import appContainers from './appContainers';
import nativeBridge from './mobilbank-native-bridge';
import backArrowBtn from './back-arrow-btn';

export const init = () => {
  appContainers();
  nativeBridge();
  backArrowBtn();
};
